export default __webpack_public_path__ + "static/media/image04.2db5e6f9.jpg";